import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { AxiosContext } from "contexts/AxiosContext";
import { EmailScheduleSettingsResponse } from "interfaces/email-settings";
import { API_URL_EMAIL_SCHEDULE_SETTINGS } from "constants/api_urls";

export const useEmailScheduleSettingsQuery = (): UseQueryResult<
  EmailScheduleSettingsResponse,
  unknown
> => {
  const { axios } = useContext(AxiosContext)!;

  return useQuery({
    queryKey: ["emailScheduleSettings"],
    queryFn: async () => {
      const { data } = await axios.get<EmailScheduleSettingsResponse>(
        API_URL_EMAIL_SCHEDULE_SETTINGS
      );
      return data;
    }
  });
};
